import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/views/home/home-page.vue'
import BookingPage from '@/views/booking/booking-page.vue'
import BookingConfirmationPage from '@/views/booking/booking-confirmation-page.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/book-appointment/'+process.env.VUE_APP_DEFAULT_LOCATION_ID_FOR_REDIRECTION+'/'+process.env.VUE_APP_DEFAULT_PROVIDER_ID_FOR_REDIRECTION+'/',
      //name: 'HomePage',
      //component: HomePage
    },
    {
      path: '/book-appointment/:locid/:staffid',
      name: 'BookingPage',
      component: BookingPage
    },
    { path: '/booking-confirmation/', 
      name: 'BookingConfirmationPage',
      component: BookingConfirmationPage 
    },
  ],
  mode: 'history'
})